import React from 'react';
import styled from 'styled-components';
import { StepIndicator } from '@telia/styleguide';
import { useLocation } from 'react-router-dom';
import { routes, capitalizeFirstLetter, backUrlAsParam } from '../../util/utils';

const StepIndicatorBar: React.FC = () => {
  let location = useLocation();

  const labels: string[] = Object.keys(routes).map((key: string, index) => {
    if (index === 0) {
      return 'Adresse';
    }

    if (key == 'prices') {
      return 'Velg pakke';
    }

    return capitalizeFirstLetter(routes[key].substring(1));
  });
  const paths = Object.keys(routes).map(route => routes[route]);

  const activeIndex = paths.indexOf(location.pathname);
  const numberOfSteps = paths.length;

  const links = paths.map((linkPath, idx) => {
    if (backUrlAsParam && idx === 0) {
      return linkPath;
    }
    return window.location.origin + window.location.pathname + '#' + linkPath;
  });

  return (
    <Container>
      <StepIndicator index={activeIndex} numberOfSteps={numberOfSteps} labels={labels} links={links} />
    </Container>
  );
};

export default StepIndicatorBar;

const Container = styled.div`
  margin: 2rem auto;
`;
